import { createContext } from "react";

import { InvoiceFormHelper } from "./InvoiceFormHelper.ts";

export const InvoiceFormContext = createContext<InvoiceFormHelper>(
  {} as InvoiceFormHelper
);
